"use client"

import WaitingState from "@/SvgIcons/WaitingState";
import styles from "./NsatBanner.module.scss";

import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { getGlobalStateValue } from "@/context/utils";
import { aonsatAssociatedPrograms } from "../Forms/ConnectModalFormIONSAT/utils";
import clsx from "clsx";
import { pushToDataLayer } from "@/helpers/gtag";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";

export default function NSATBanner({ associatedPrograms }) {
   const modalDispatch = useModalDispatch();
  
    const onClickHanlder = () => {
      modalDispatch({
        type: IModalActions.OpenModal,
        data: {
          modalType: ModalTypes.ConnectModalAONSAT,
          modalData: {
            heading: "Register for Amity Online NSAT 2026",
            associatedPrograms: aonsatAssociatedPrograms,
            submitBtnText: "START TEST",
            rfiCase: "REDIRECT_TO_APPLICATION_JOURNEY",
          },
        },
      });

      setTimeout(()=>{

       window?.webengage?.track("ONSAT Banner Clicked", {
        "Section Name":"Middle Banner",
        "Page Type": getGlobalStateValue("pageType"),
       });
      },2000)
    };

  return (
    <section className={styles.banner}>
      <div className={styles.circleLarge}></div>

      {/* Left Content */}
      <div className={styles.content}>
        <h2 className={styles.heading}>
          Amity Online {" "}
          <span className={clsx(styles.textYellow, "lining-nums")}>
             NSAT 2026 <br />
          </span>
        </h2>
        <p className={styles.mwebHeading}>Get up to  <span className={styles.textYellow}> 100% Scholarship!   </span ></p>
        <p className={styles.subheading}>National Scholarship Aptitude Test</p>
        <p className={styles.Mwebsubheading}>Take Amity Online National Scholarship Aptitude Test 2026</p>


        <p className={styles.description}>
          Take the test and get a chance to win up to{" "}
          <strong className={styles.highlightText}>
            100% scholarship.
          </strong>
        </p>

        <button onClick={onClickHanlder} className={styles.ctaButton}>
          Register Now
        </button>

        <p className={styles.urgency}>
          <span className={styles.urgencyIcon}><WaitingState /> </span>
          Hurry! Registrations closing soon
        </p>
      </div>

      {/* Right Image */}
      <div className={styles.imageWrapper}>
        <UnivoImage
          src={IMAGE_ASSETS.nsatGraduation}
          alt="Amity Online Graduating Students"
          className={styles.image}
          width={560}
          height={420}
          sizes="(max-width: 768px) 90vw, 560px"
          loading="lazy"
          fetchPriority="low"
        />
      </div>
    </section>
  );
}